/**
 * Ersatz für app.announce() aus src/app.js: schreibt in die aria-live-Region
 * #app-announcer (siehe AppShell). Leert den Text zuerst und setzt ihn im
 * queueMicrotask, damit identische Folgenachrichten erneut angesagt werden.
 * Reine DOM-Funktion (kein Hook nötig), damit sie auch aus Nicht-React-Modulen
 * wie der Autosave-Queue aufgerufen werden kann.
 */
export function announce(message: string): void {
  const element = document.getElementById("app-announcer");
  if (!element) return;
  element.textContent = "";
  queueMicrotask(() => {
    element.textContent = message;
  });
}
